import(/* webpackMode: "eager" */ "E:\\vhosts\\paykanpars.com\\httpdocs\\node_modules\\@mui\\material\\Box\\index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\vhosts\\paykanpars.com\\httpdocs\\src\\app\\(pages)\\(general)\\(home)\\components\\features-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\vhosts\\paykanpars.com\\httpdocs\\src\\app\\(pages)\\(general)\\(home)\\components\\filter\\advanced-search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\vhosts\\paykanpars.com\\httpdocs\\src\\app\\(pages)\\(general)\\(home)\\components\\product-slider-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SwrConfig"] */ "E:\\vhosts\\paykanpars.com\\httpdocs\\src\\lib\\swr-config.tsx");
